export default {
  "user_ten": undefined,
  "user_loai": undefined,
  "user_anh": undefined,
  "dia_chi_tinh_id": undefined,
  "dia_chi_xa_id": undefined,
  "user_dia_chi": undefined,
  "ho_ten": undefined,
  "chuc_vu": undefined,
  "user_dien_thoai": undefined,
  "user_so_giay_to": undefined,
};
